module.exports = __webpack_public_path__ + "img/SES_Megaliner_Overview.e5e0c655.jpg";